import { render } from "./ImageWrapper.vue?vue&type=template&id=f2b5a682"
import script from "./ImageWrapper.vue?vue&type=script&lang=js"
export * from "./ImageWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__